import React from 'react';
import { Box, Typography } from '@mui/material';
import { ColumnFlexBox } from '../../FlexBox';

/**
 * OutcomeBars — the outcome legend next to the donut (mockup screen 9): a
 * colored swatch, the label, and its percentage. `items: [{ label, value,
 * color }]` where value is a percentage.
 */
const OutcomeBars = function OutcomeBars({ items = [] }) {
  return (
    <ColumnFlexBox sx={{ flex: 1, minWidth: 0, gap: 1.1 }}>
      {items.map((item) => (
        <Box
          key={item.label}
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <Box
            sx={{
              width: 11,
              height: 11,
              flex: 'none',
              borderRadius: '3px',
              bgcolor: item.color,
              border: item.color === '#eef1f6' ? '1px solid #cbd5e1' : 'none',
            }}
          />
          <Typography sx={{ fontSize: 13, color: '#3a3a42', flex: 1 }} noWrap>
            {item.label}
          </Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#1a1a1f' }}>
            {`${item.value}%`}
          </Typography>
        </Box>
      ))}
    </ColumnFlexBox>
  );
};

export default OutcomeBars;
